export const INTEGRATOR_FILTERS = {
  ALL: 'ALL',
  APPOINTMENTS: 'APPOINTMENTS',
  CLASSES: 'CLASSES',
  FOOD_AND_BEVERAGE: 'FOOD_AND_BEVERAGE',
  SEARCH: 'SEARCH',
};
